import sessionStorageUtils from './sessionStorageUtils';
export const IS_INTEGRATED_FORMS_APP_KEY = 'WP_IS_INTEGRATED_FORMS_APP';
let isIntegratedFormsAppCached = null;
export const clearIsIntegratedFormsAppCachedForTests = () => {
  isIntegratedFormsAppCached = null;
};

const checkIfReferredFromIntegratedApp = () => {
  if (!document.referrer || !window.hubspot) {
    return false;
  }

  const referrer = new URL(document.referrer);
  const portalId = window.hubspot.portal && window.hubspot.portal.id;
  return referrer.pathname === `/integrated-forms-ui/${portalId}/create/type` || referrer.pathname === `/integrated-forms-ui/${portalId}/dashboard`;
};

const checkAndCacheIsIntegratedFormsApp = () => {
  const isIntegratedAppSession = sessionStorageUtils.getItem(IS_INTEGRATED_FORMS_APP_KEY);

  if (isIntegratedAppSession === null) {
    isIntegratedFormsAppCached = checkIfReferredFromIntegratedApp();
    sessionStorageUtils.setItem(IS_INTEGRATED_FORMS_APP_KEY, isIntegratedFormsAppCached.toString());
  } else {
    isIntegratedFormsAppCached = isIntegratedAppSession === 'true';
  }
};

const isIntegratedFormsApp = () => {
  if (isIntegratedFormsAppCached === null) {
    checkAndCacheIsIntegratedFormsApp();
  }

  return isIntegratedFormsAppCached;
};

export default {
  isIntegratedFormsApp
};